(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.grouppractice', [
        'uwAgenda.global'
    ]);
    module.config(['$stateProvider', GroupPracticeRoutes]);

    function GroupPracticeRoutes($stateProvider) {
        $stateProvider  
            .state('Home.GroupPractice', {
                url: 'group-practice',
                templateUrl: '/app/settings/grouppractice/grouppractice.html',
                controller: 'GroupPracticeController',
                controllerAs: 'vm',               
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'grouppractice' | translate}}"
                }
            })          
            .state('Home.GroupPractice.WaitingRooms', {
                url: '/waitingrooms',
                templateUrl: '/app/settings/grouppractice/waitingroom/waitingroom-overview.html',
                controller: 'WaitingRoomOverviewController',
                controllerAs: 'vm',                          
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'waitingrooms' | translate}}"
                }
            })
            .state('Home.GroupPractice.InternalLocations', {
                url: '/internal-locations',
                templateUrl: '/app/settings/grouppractice/location/location-overview.html',
                controller: 'LocationOverviewController',
                controllerAs: 'vm',                             
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'internal_locations' | translate}}"
                }
            });
    }
})();